module.exports = __webpack_public_path__ + "static/media/frc-christmas-image-1.2ea00169.jpg";